module.exports = __webpack_public_path__ + "static/img/bg-tr.bb64eff2.png";